// ============================================
// ФОРМА ПОДПИСКИ НА EMAIL РАССЫЛКУ (BLOCK20)
// ============================================

(function() {
  function init() {
  const email20 = document.getElementById('email20');
  const comment20 = document.getElementById('comment20');
  const submitBtn20 = document.getElementById('submitBtn20');
  const antibotLabel20 = document.getElementById('antibotLabel20');

  // Генерируем антибот для формы подписки
  let antibot20 = null;
  
  function generateAntibot20() {
    const num1 = Math.floor(Math.random() * 50) + 10; // от 10 до 59
    const num2 = Math.floor(Math.random() * num1); // от 0 до num1-1
    return { num1, num2, answer: num1 - num2 };
  }

  // Функция обновления метки антибота
  function updateAntibotLabel20(label, antibot) {
    if (!label || !antibot) return;
    
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    
    let questionText;
    if (t && t.antibot_question) {
      questionText = t.antibot_question
        .replace('{num1}', antibot.num1)
        .replace('{num2}', antibot.num2);
    } else {
      questionText = `Сколько будет ${antibot.num1} - ${antibot.num2}?`;
    }
    
    label.setAttribute('data-question', questionText);
    const requestSpan = label.querySelector('.request');
    const requestHtml = requestSpan ? requestSpan.outerHTML : '';
    label.innerHTML = `${questionText}${requestHtml}`;
  }

  // Функция проверки антибота
  function checkAntibot20(userAnswer, correctAnswer) {
    if (!userAnswer || !userAnswer.trim()) return false;
    const answer = parseInt(userAnswer.trim(), 10);
    if (isNaN(answer)) return false;
    return answer === correctAnswer;
  }

  // Функция валидации email
  function validateEmail20(email) {
    if (typeof validateEmail === 'function') {
      return validateEmail(email);
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Функция обновления состояния кнопки
  function updateSubmitButton20() {
    if (!email20 || !comment20 || !submitBtn20 || !antibot20) return;
    
    const isEmailValid = email20.value && validateEmail20(email20.value);
    const isAntibotValid = checkAntibot20(comment20.value, antibot20.answer);
    
    if (isEmailValid && isAntibotValid) {
      submitBtn20.disabled = false;
      submitBtn20.style.opacity = '1';
      submitBtn20.style.cursor = 'pointer';
    } else {
      submitBtn20.disabled = true;
      submitBtn20.style.opacity = '0.5';
      submitBtn20.style.cursor = 'not-allowed';
    }
  }

  // Инициализация формы
  if (email20 && comment20 && submitBtn20 && antibotLabel20) {
    // Генерируем антибот
    antibot20 = generateAntibot20();
    updateAntibotLabel20(antibotLabel20, antibot20);
    
    // Сохраняем глобально для использования в updateAllAntibotLabels
    window.antibot20 = antibot20;
    window.antibotLabel20 = antibotLabel20;

    // Обработчики для email
    email20.addEventListener('input', () => {
      if (email20.value && !validateEmail20(email20.value)) {
        email20.classList.add('error');
      } else {
        email20.classList.remove('error');
      }
      updateSubmitButton20();
    });

    email20.addEventListener('blur', () => {
      if (email20.value && !validateEmail20(email20.value)) {
        email20.classList.add('error');
      } else {
        email20.classList.remove('error');
      }
      updateSubmitButton20();
    });

    // Обработчики для антибота
    comment20.addEventListener('input', () => {
      updateSubmitButton20();
    });

    // Обработчик отправки формы
    submitBtn20.addEventListener('click', (e) => {
      e.preventDefault();
      
      let isValid = true;
      const missingFields = [];
      
      // Валидация email
      if (!email20.value || !validateEmail20(email20.value)) {
        email20.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        email20.classList.remove('error');
      }
      
      // Валидация антибота
      if (!checkAntibot20(comment20.value, antibot20.answer)) {
        comment20.classList.add('error');
        isValid = false;
        missingFields.push('Антибот');
      } else {
        comment20.classList.remove('error');
      }
      
      if (isValid) {
        // Здесь можно добавить отправку данных на сервер
        console.log('Форма подписки отправлена:', {
          email: email20.value,
          form_name: 'Подписка на email рассылку'
        });
        
        // Показываем сообщение об успехе (можно заменить на модальное окно)
        alert('Спасибо за подписку!');
        
        // Очищаем форму
        email20.value = '';
        comment20.value = '';
        
        // Генерируем новый антибот
        antibot20 = generateAntibot20();
        updateAntibotLabel20(antibotLabel20, antibot20);
        window.antibot20 = antibot20;
        
        // Обновляем состояние кнопки
        updateSubmitButton20();
      } else {
        alert(`Пожалуйста, заполните все поля правильно: ${missingFields.join(', ')}`);
      }
    });

    // Инициализация состояния кнопки
    updateSubmitButton20();
  }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
